import { useLazyQuery } from '@apollo/client';
import {
  CustomRole,
  GET_CUSTOM_ROLE_BY_ID,
  GetCustomRoleResponse,
} from '../../../../apollo/queries/v3/RolesNPermissions/getCustomRoleById.queries';
import { RNPToastHelper } from '../../RNPToaster';

type Props = {
  onComplete: (customRole: CustomRole) => void;
};

type ReturnType = [(roleId: string) => void, { loading: boolean }];

const useGetCustomRoleByIdAPI = ({ onComplete }: Props): ReturnType => {
  const [getCustomRole, { loading }] = useLazyQuery<GetCustomRoleResponse>(
    GET_CUSTOM_ROLE_BY_ID,
    {
      onCompleted: (res) => {
        if (res.customRole) {
          onComplete(res.customRole);
        }
      },
      onError: (e) => {
        RNPToastHelper.error();
      },
    },
  );

  const getRoleById = (roleId: string) => {
    const variables = { input: { id: roleId } };
    getCustomRole({ variables });
  };

  return [getRoleById, { loading }];
};

export default useGetCustomRoleByIdAPI;
